// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultLayout_container__RMvUB","header":"DefaultLayout_header__IO3Yz","main":"DefaultLayout_main__xMhk6"};